import { render, staticRenderFns } from "./ItemRecordClient.vue?vue&type=template&id=42c2f159&scoped=true&lang=pug&"
import script from "./ItemRecordClient.vue?vue&type=script&lang=js&"
export * from "./ItemRecordClient.vue?vue&type=script&lang=js&"
import style0 from "./ItemRecordClient.vue?vue&type=style&index=0&id=42c2f159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c2f159",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
